@if (authenticated) {
    <div class="wrapper">
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </div>
}